<template>
  <!-- Typical User -->
  <div
    @click="toggleProfileOverlay"
    v-if="env == 'development'"
    class="env_badge env_badge_dev"
  >
    <ProfileImage
      v-if="!profilePicture"
      :label="profileInitials"
      class="mr-2 profile_initials profile_btn"
      shape="circle"
    />
    <ProfileImage
      v-else
      :image="profilePicture"
      class="mr-2 profile_image profile_btn"
      shape="circle"
    />
    <h5>DEV</h5>
  </div>
  <div
    @click="toggleProfileOverlay"
    v-if="env == 'production'"
    class="env_badge env_badge_prod"
  >
    <ProfileImage
      @click="toggleProfileOverlay"
      v-if="!profilePicture"
      :label="profileInitials"
      class="mr-2 profile_initials profile_btn"
      shape="circle"
    />
    <ProfileImage
      @click="toggleProfileOverlay"
      v-else
      :image="profilePicture"
      class="mr-2 profile_image profile_btn"
      shape="circle"
    />
    <h5>LIVE</h5>
  </div>
  <!-- Drop Down Menu -->
  <OverlayPanel ref="profileol" width="300px">
    <div class="top_nav_sub_menu">
      <h3>{{ companyName }}</h3>
      <span class="body_copy_s"
        >{{ usersName.firstName }} {{ usersName.lastName }}</span
      >
      <hr class="divider_line" />
      <div class="top_nav_list_menu" @click="logOut()">
        {{ $t("global.log_out") }}
      </div>
    </div>
  </OverlayPanel>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    countryCode: {
      type: String,
      default: "GLOBAL",
    },
  },
  data() {
    return {
      env: process.env.NODE_ENV,
    };
  },
  computed: {
    ...mapGetters("userData", [
      "usersName",
      "companyName",
      "profilePicture",
      "profileInitials",
    ]),
  },
  methods: {
    // Toggles the Overlay Dialog to show/hide
    toggleProfileOverlay(event) {
      this.$refs.profileol.toggle(event);
    },
    // Closes the overlay
    closeOverlay() {
      this.$refs.profileol.hide();
    },
    // Logs the user out of the application via Auth0
    logOut() {
      this.authLogOut();
      this.$auth0.logout();
      window.localStorage.removeItem("vuex");
    },
    ...mapActions(["authLogOut"]),
  },
};
</script>

<style scoped>
.profile_line {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: var(--border-radius);
  cursor: pointer;
}

.profile_line:hover {
  background: var(--grey-light);
}

.env_badge {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0px 15px 0px 0px;
  height: fit-content;
  margin-top: 4px;
  margin-right: 10px;
  border-radius: 20px;
  cursor: pointer;
}
.env_badge_dev {
  background: var(--blue-light);
}

.env_badge_prod {
  background: var(--yellow-light);
}
</style>
